<!--
 * @Description:线索审核
 * @Author: cxh
 * @Date: 2022-06-10 13:33:54
 * @LastEditTime: 2023-03-15 15:49:06
 * @LastEditors: mdb
-->
<template>
  <dc-layout-main>
    <dc-layout-content>
      <cos-table
        serial
        :columns="columns"
        @fetch="fetch"
        @mask="showMask"
        rowKey="recordId"
        :row-selection="{ onChange: onSelectRowsChange, getCheckboxProps: getCheckboxProps }"
        v-model:search="queryForm"
        ref="tableRef"
        tableId="DcCosFbuApprovalClue"
      >
        <template #search>
          <a-form :model="queryForm">
            <dc-form-item name="auditStatus" label="审核状态">
              <a-radio-group
                v-model:value="queryForm.auditStatus"
                optionType="button"
                @change="search"
                :options="[{ label: '全部', value: undefined }, ...applyStateEnum]"
              />
            </dc-form-item>
            <dc-form-item label="客户名称">
              <a-input v-model:value="queryForm.customerName" allowClear placeholder="请输入" />
            </dc-form-item>
            <dc-form-item name="contactName" label="联系人名称">
              <a-input v-model:value="queryForm.contact.name" allowClear placeholder="请输入" />
            </dc-form-item>
            <dc-form-item label="手机号">
              <a-input v-model:value="queryForm.contact.keyword" allowClear placeholder="请输入" />
            </dc-form-item>
            <dc-form-item name="applicant" label="申请人">
              <user-select v-model:value="queryForm.applicant" />
            </dc-form-item>
            <dc-form-item label="申请时间">
              <cos-range-picker v-model:startTime="queryForm.startApplyTime" v-model:endTime="queryForm.endApplyTime" />
            </dc-form-item>
            <dc-form-item name="auditor" label="审核人">
              <user-select v-model:value="queryForm.auditor" />
            </dc-form-item>
            <dc-form-item label="审核时间">
              <cos-range-picker v-model:startTime="queryForm.startAuditTime" v-model:endTime="queryForm.endAuditTime" />
            </dc-form-item>
          </a-form>
        </template>
        <template #bodyCell="{ column, record, text }">
          <template v-if="column.dataIndex === 'auditStatus'">
            <dc-status :enums="stateColorEnum" :value="text" />
          </template>
          <template v-if="column.dataIndex === 'customerRegion'">
            <CustomerAreaCascaderText appId="cos_fbu" :value="text" />
          </template>
          <template v-if="column.dataIndex === 'action'">
            <more-button>
              <a-button
                type="link"
                v-if="record.auditStatus === 1"
                v-permission="'fbu_cluesaudit_check_btn'"
                @click="handleAppaly(record)"
                >审核</a-button
              >
            </more-button>
          </template>
        </template>
        <template #button>
          <a-button type="primary" @click="handleAppaly()" v-permission="'fbu_cluesaudit_check_btn'">批量审核</a-button>
        </template>
      </cos-table>
      <!---审核弹框--->
      <applyModel ref="applyModelRef" @success="success" />
    </dc-layout-content>
  </dc-layout-main>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'
import { clueAuditList, salesClueDetail } from '@/api/gucangSales/clueManage'
import { clueTypeEnum } from '@/views/gucangSales/clueManage/dataConfig'
import applyModel from './applyModel.vue'
import CustomerAreaCascaderText from '@/components/CustomerAreaCascader/CustomerAreaCascaderText.vue'
import type { SalesClueListItem } from '@/typings/api/clueManage'
const tableRef = ref()
const selectedRows = ref<SalesClueListItem[]>([])
const queryForm = ref({
  auditStatus: 1,
  contact: {
    type: 1
  }
})
const applyModelRef = ref()
const applyStateEnum = [
  { label: '待审核', value: 1 },
  { label: '已通过', value: 2 },
  { label: '已驳回', value: 3 }
]
const stateColorEnum = [
  {
    name: '待审核',
    value: 1,
    color: '#1d4cd2'
  },
  {
    name: '已通过',
    value: 2,
    color: '#3FAC46'
  },
  {
    name: '已驳回',
    value: 3,
    color: '#DF443B'
  }
]
const fetch = (params: object, callBack: (res: any) => void) => {
  clueAuditList({
    ...params
  }).then((res) => {
    callBack(res)
  })
}
// 获取详情联系人信息
const showMask = (record: SalesClueListItem, callBack: (res: any) => void) => {
  salesClueDetail({ clueId: record.clueId }).then((res) => {
    const { contact } = res.data
    callBack({
      contactName: contact.name,
      contactMobile: contact.mobile
    })
  })
}
const onSelectRowsChange = (keys: string[], rows: SalesClueListItem[]) => {
  selectedRows.value = rows
}
// 待审核&&当前
const getCheckboxProps = (record: SalesClueListItem) => ({
  disabled: !(record.auditStatus === 1), // Column configuration not to be checked
  auditStatus: record.auditStatus
})

const success = () => {
  tableRef.value.fetch()
}
const search = () => {
  tableRef.value.fetch()
}
const handleAppaly = (row: SalesClueListItem) => {
  let data: any = []
  if (row && row.clueId) {
    data.push(row)
  } else {
    data = selectedRows.value
  }
  applyModelRef.value.toggle(data)
}
const columns = computed(() => [
  {
    title: '客户名称',
    dataIndex: 'customerName',
    cosType: 'link',
    path: '/fbu/salesClue/view',
    query: ['clueId', 'recordId', 'isApplay=1'],
    fixed: 'left'
  },
  {
    title: '申请人',
    dataIndex: 'createByName'
  },
  {
    title: '申请时间',
    dataIndex: 'applyTime'
  },
  {
    title: '申请原因',
    dataIndex: 'applyReason'
  },
  {
    title: '审核人',
    dataIndex: 'auditorName'
  },
  {
    title: '审核时间',
    dataIndex: 'auditTime',
    width: 150
  },
  {
    title: '审核状态',
    dataIndex: 'auditStatus'
  },
  {
    title: '联系人名称',
    dataIndex: 'contactName',
    cosType: 'mask'
  },
  {
    title: '手机号',
    dataIndex: 'contactMobile',
    cosType: 'mask'
  },
  {
    title: '客户区域',
    dataIndex: 'customerRegion'
  },
  {
    title: '线索类型',
    dataIndex: 'clueType',
    dicData: clueTypeEnum
  },
  {
    title: '前负责人',
    dataIndex: 'beforeFollowerName'
  },
  {
    title: '线索创建时间',
    width: 150,
    dataIndex: 'clueCreateTime'
  },
  {
    title: '操作',
    dataIndex: 'action',
    width: 100,
    fixed: 'right'
  }
])
</script>
<script lang="ts">
export default { name: 'DcCosFbuCluesAudit' }
</script>
